import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-notif',
  templateUrl: './notif.component.html',
  styles: []
})
export class NotifComponent implements OnInit {

  spaceId;
  limit = 1000;
  notifs: any = [];

  constructor(
    private route: ActivatedRoute,
    private _api: ApiService,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(
      params => {
        if (params['id']) {
          this.spaceId = params['id'];
          this._api.notifs
            .list({
              space: this.spaceId,
              limit: this.limit
            })
            .subscribe(
              (data) => {
                this.notifs = data.results;
              },
              (errors) => {
              });
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/notif/notif.component.ts